import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useContactStore } from "../../../../store/useContactStore";
import { formatPhoneNumberWithdot } from "../../../../helper";
// import { HashLink } from 'react-router-hash-link';
import Loader from '../../../Loader';

const ContactForm = () => {

    const [formData, setFormData] = useState({
        companyName: "",
        contactName: "",
        email: "",
        phoneNumber: "",
        planLink: "",
        comment: "",
    });
    const [loading, setLoading] = useState(false)
    let { getContactInfo, contact, postQuery } = useContactStore()

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.companyName || !formData.contactName || !formData.email || !formData.phoneNumber) {
            alert("Please fill all required fields!");
            return;
        }
        setLoading(true)
        await postQuery(formData)
        setLoading(false)

    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const fetchContactPage = async () => {
        if (contact) return

        await getContactInfo()
    }

    useEffect(() => {
        fetchContactPage()
    }, [])

    return (
        <section className="contact-section" id="contactForm">
            <Container>
                <h4 className="text-center mb-xl-5 mb-3">
                    FILL OUT THE CONTACT FORM BELOW
                </h4>
                <Loader loading={loading}>
                    <Form onSubmit={handleSubmit} className="mt-3">
                        <Row className="g-3 contact-form-wraper">
                            <Col md={6} className="mt-0">
                                <Form.Group className="mb-xl-3 mb-2" controlId="companyName">
                                    <Form.Control
                                        type="text"
                                        placeholder="Company Name"
                                        value={formData?.companyName}
                                        onChange={handleChange}
                                        name='companyName'
                                        required />
                                </Form.Group>

                                <Form.Group className="mb-xl-3 mb-2" controlId="contactName">
                                    <Form.Control type="text"
                                        placeholder="Contact Name"
                                        value={formData?.contactName}
                                        onChange={handleChange}
                                        name='contactName'
                                        required />
                                </Form.Group>
                                <Form.Group className="mb-xl-3 mb-2" controlId="email">
                                    <Form.Control
                                        type="email"
                                        placeholder="Email Address"
                                        value={formData?.email}
                                        onChange={handleChange}
                                        name='email'
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="phone" className="mb-xl-3 mb-2">
                                    <Form.Control
                                        type="tel"
                                        placeholder="Phone Number"
                                        value={formData?.phoneNumber}
                                        onChange={handleChange}
                                        name='phoneNumber'
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="mt-0">
                                <Form.Group controlId="linkToPlans" className="mb-xl-3 mb-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Link to Plans"
                                        value={formData?.planLink}
                                        onChange={handleChange}
                                        name='planLink'
                                    />
                                </Form.Group>
                                <Form.Group controlId="questionComment" className="mb-xl-3 mb-2">
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Question/Comment"
                                        value={formData?.comment}
                                        onChange={handleChange}
                                        name='comment'
                                        rows={3}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="text-center mt-xl-4 mt-lg-3 mt-2 contact-btn-holder">
                            <Button
                                type="submit"
                                className="btn btn-solid-orange"
                            >
                                Submit Project
                            </Button>
                        </div>
                    </Form>
                </Loader>
                <div className="emergenci-text text-center mt-5 ">
                    <h4 className="mb-1">
                        FOR EMERGENCIES, CALL OR TEXT US
                    </h4>
                    <h4 className="text-danger fw-medium">{formatPhoneNumberWithdot(contact?.phoneNumber)}</h4>
                </div>
            </Container>
        </section>
    );
};

export default ContactForm;
